import React from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../../../../utils/fp/missing-ts-parts";
import { betweenMediaQuery, CSS_MQ } from "../../../../../styles/breakpoints";
import { CSS_COLORS } from "../../../../../styles/styles-css-variables";
import { SwarovskiLink } from "../../../../../components/_shared-components/ui-elements/SwarovskiLink";
import { FONTS } from "../../../../../styles/fonts";
import { NewLabel, labelWithNewAttributeClassName } from "../../../../../components/_shared-components/new/new-label";
import { VariantPickerVariation_ClothSize } from "../utils";
import cn from "classnames";
import { PDPAction } from "../../state/types";
import { InternalLinkOrButtonForPickers } from "./InternalLinkOrButtonForPickers";

export const ClothSizeVariantView: ReactTFC<{
  variation: Omit<VariantPickerVariation_ClothSize, "tag">;
  onPDPActionClick: (pdpAction: PDPAction) => void;
}> = props => {
  const Content = (
    <React.Fragment>
      <span
        className={cn({
          selected: props.variation.state === "selected",
          disabled: props.variation.state === "disabled",
        })}
        css={styles}
      >
        <span
          className={labelWithNewAttributeClassName}
          css={[
            css`
              padding-left: 12px;
              padding-right: 12px;
            `,
          ]}
        >
          {props.variation.name}
          {props.variation.isNew && (
            <NewLabel
              css={css`
                font-size: 0.5em;
              `}
            />
          )}
        </span>
      </span>
    </React.Fragment>
  );

  const { target } = props.variation;

  return (
    <InternalLinkOrButtonForPickers action={target} attachStyles={linkStyles}>
      {Content}
    </InternalLinkOrButtonForPickers>
  );
};

const linkStyles = css`
  background: white;

  text-decoration: none;
  color: inherit;

  .active > & {
    border: 2px solid ${CSS_COLORS.Green};

    box-shadow: 0 0 10px 0 rgba(31, 112, 87, 0.5);
  }

  .disabled > & {
    opacity: 0.3;
    cursor: not-allowed;
  }

  &:focus {
    outline: none;
  }
`;

const styles = [
  FONTS.SwarovskiFutura300,
  css`
    font-size: 14px;
    ${CSS_MQ.atLeastMd} {
      font-size: 15px;
    }

    letter-spacing: 0.6px;

    border-width: 2px;
    border-style: solid;

    // center visually
    padding-top: 2px;

    --h: 45px;

    min-width: var(--h);
    border-radius: var(--h);
    height: var(--h);

    display: flex;
    justify-content: center;
    align-items: center;

    border-color: ${CSS_COLORS.Grey6};

    // Safari needs it for box-shadow...
    // I don't know... why
    position: relative;

    &.selected {
      outline: none;
      border-width: 2px;
      border-color: ${CSS_COLORS.Green};

      box-shadow: 0 0 10px 0 rgba(31, 112, 87, 0.5);
    }

    &.disabled {
      border-color: ${CSS_COLORS.Grey0};
      color: ${CSS_COLORS.Grey5};
      cursor: not-allowed;
    }
  `,
];
